import { BCMSCurrency, BCMSRecord, DisabledPrompt, useBCMSContext, useParams, useRoute, useWorkflowStep } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import { MainContentSection } from "components/shared/containers/MainContentContainer";
import CustomSelect, { CustomSelectItem } from "components/ui/CustomSelect";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import UIDatePicker from "components/ui/UIDatePicker ";
import UIRadio from "components/ui/UIRadio";
import { getDefault, getWorkflowSteps } from "components/workflows/OneTimePaymentWorkFlow";
import { Card, LinkedAccount, Transaction } from "model";
import React, { useState } from "react";
import { SVGAsset } from "res";

import UIAmountInput from "components/ui/UIAmountInput";
import "./styles.css";

/**
 * @function OneTimeFormView
 * @param {STRING} minAmount - Sets the minimum amount.
 * @param {STRING} minDate - Sets the minimum amount date.
 * @param {STRING} statementBalance - Sets the statement balance.
 * @param {STRING} statementDate - Sets the statement balance date.
 * @param {STRING} currentBalance - Sets the current balance
 * @param {STRING} acctType - Sets the account type.
 * @param {STRING} acctNum - Sets the account number.
 * @param {STRING} fiName - Sets the financial institution name.
 * @return {React.Component}
 * @exported true
 * @description this is the form for making a one time payment. This is the first step in the one time payment workflow.
 */
export default function OneTimeFormView(props) {
    const globalController = useBCMSContext();
    const defaultCard =   globalController.state.branding.options.include_debit_chw23  !== "false" ? "0" : "1";
    const cardID = useParams().cardID ?? defaultCard;
    const card = Card.initByID(cardID);
    const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
    BCMSRecord.globalControllerFor([ Card ,LinkedAccount,Transaction ], globalController);
    const accounts = LinkedAccount.initAll().reduce((accounts,account)=>{
        if(account.type !== "credit" && account.status === "active"&& account.id === "0"){
            accounts.push( <CustomSelectItem value={account.id} >{`${account.type} ${account.last_four_digit_number} - ${account.fi_name}`}</CustomSelectItem>)
        }
       return accounts;
    },[]);

    const [getCustomAmount ,setCustomAmount] = useState("");
    const [selectRadio ,setSelectRadio] = useState(false);
   
   
    const updateSelect = ()=>{
        workflowStep.update([ "amountSelect" ], "Custom Amount");
        setSelectRadio(true)
    };
    const updateDate = date=>{
        workflowStep.update([ "date" ],date);
      };
      const updateAmount = (selected,amount)=>{
        setSelectRadio( amount !== "Minimum Due" && amount !== "Statement Balance"  && amount !== "Current Balance");
       
             workflowStep.update([ "amountSelect" ],amount);
      };
      const updateAccount = account=>{
        workflowStep.update([ "account" ],account);
      };
    
  
    const navigate = useRoute();


    const minAmount = card.minPaymentAmount.format() ?? "[$xx.xx]";
    const dateDue = card.dateDue.format("M d") ?? "[Mon dd]";
    const statementBalance = card.statementBalance.format() ?? "[$xx.xx]";
    const statementDate = card.lastStatementDate.format("M d") ?? "[Mon dd]";
    const currentBalance = card.statementBalance.format() ?? "[$xx.xx]";
    const acctType = card.acctType ?? "[account type]";
    const acctNum = card.acctNum ?? "[account number]";
    const fiName = card.fiName ?? "[FI Name]";
    const next = evt => {
        let amount ="100";
        let amountSelect = workflowStep.getStepState.amountSelect ?? "Minimum Payment Due" ;
        switch(workflowStep.getStepState.amountSelect){
            case "Minimum Due":
                amount=minAmount;
                break;
            case "Statement Balance":
                amount=statementBalance;
                break;
            case "Current Balance":
                amount=currentBalance;
                break;  
                case undefined:
                    amountSelect =  "Minimum Due"
                    amount=minAmount;    
                break;        
            default:  
            amountSelect = "Custom Amount"
            amount=getCustomAmount === "0.00"?minAmount:getCustomAmount ;         
        }
       
        workflowStep.update([ "amountSelect" ],amountSelect);
        workflowStep.update([ "amount" ],BCMSCurrency.init(amount).format());
        workflowStep.workflow.nextStep( workflowStep.getStepState);
    };
    return (
        <FormContainer className="one-time-form-view">
            <FormRow className="payment-date-row">
                <UIDatePicker dateLabel="Payment Date" onChange={updateDate} value={workflowStep.getStepState.date}/>
            </FormRow>
            <MainContentSection text="Amount">
                <FormRow className="minimum-due-row">
                    <UIRadio name="payment-option" label="Minimum Due" subText={`Due by ${dateDue}`} rightText={minAmount}  onChange={updateAmount}/>
                </FormRow>
                <FormRow className="statement-balance-row">
                    <UIRadio name="payment-option" label="Statement Balance" subText={`As of ${statementDate}`} rightText={statementBalance}  onChange={updateAmount}/>
                </FormRow>
                <FormRow className="current-balance-row">
                    <UIRadio name="payment-option" label="Current Balance" rightText={currentBalance}  onChange={updateAmount}/>
                </FormRow>
                <FormRow className="custom-amount-row">
                    <UIRadio label={<UIAmountInput placeholder="Custom Amount" value={getCustomAmount} onBlur={setCustomAmount} onClick={updateSelect}/>} name="payment-option"  onChange={updateAmount}  value={selectRadio}/>
                </FormRow>
            </MainContentSection>
            <MainContentSection text="Account">
                <FormRow className="payment-account-row capitalize">
                <DisabledPrompt>
                        <CustomSelect label="Payment Account" value="0" onChange={updateAccount}>
                       {accounts}
                        </CustomSelect>
                  </DisabledPrompt> 
                </FormRow>
                <div className="flex-container flex-horizontal align-center-container info-container">
                    <div className="set-width left-icon-container">
                        <SVGAsset id="InformationIcon" />
                    </div>
                    <div className="flex-width">
                        <span className="sub-text">Payments can be scheduled up to XXX days in advance.</span>
                    </div>
                </div>
                <FormButtonContainer>
                    <UIPrimaryButton text="Review" onClick={next}/>
                    <UICancelButton onClick={() => {navigate("/home/payments/1")}} text="Cancel" />
                </FormButtonContainer>
            </MainContentSection>
        </FormContainer>
    )
}
